<div class="field">
    <div *ngIf="label">
        <label class="bold" [id]="'lbl'+question_id" for="{{question_id}}" [attr.aria-label]="label" style="display:inline;" [attr.aria-hidden]="displayHelpText">
            <span [hidden]="hide_label">{{label}}</span>
            <div *ngIf="displayHelpText === false" class="label-spacer-sm"></div>
        </label>
        <button tabindex="-1" aria-pressed="false" type="button" class="help" title="more info" *ngIf="displayHelpText" placement="top-left" [attr.aria-label]="label" ngbPopover="{{help_text}}" popoverTitle="More Info:">?</button>
    </div>
    <div class="" *ngIf="isInvalid">
        <p [class.error]="isInvalid">{{error_text}}</p>
    </div>
    <div [formGroup]="paramFormGroup">
        <span class="optional-text" *ngIf="!required">(Optional)</span>
        <div *ngIf="displayHelpText === true" class="label-spacer-vsm"></div>
        <div *ngIf="readOnly; else editMode">
            <label>{{ value }}</label>
        </div>
        <ng-template #editMode>
            <input #input [class.error]="isInvalid" [value]="value" [attr.id]="question_id" [id]="question_id" [attr.aria-label]="getAriaLabel()" [name]="code" [attr.name]="code" autocomplete="{{isautocomplete? 'on':'off'}}" [type]="fieldType" [pattern]="pattern"
                [formControl]="inputControl" [placeholder]="placeholder===null?'':placeholder" [minlength]="minlength" [maxlength]="maxlength" [min]="min" [max]="max" attr.data-cy="{{code}}" [mask]="mask" >
        </ng-template>

    </div>
</div>
